export const formTypes = {
    Hexagon: 'hexagon-form',
    Ellipse: 'ellipse-form',
    None: 'none-form',
    ArrowRight: 'arrow-right-form',
    ArrowLeft: 'arrow-left-form',
    StopSign: 'stop-sign-form',
    RotatedSquare: 'rotated-square-form',
    Triangle: 'triangle-form',
    Oval: 'oval-form',
};
/** Who an admin can bind a template to. Rutab keeps it a global template. */
export const templateOwnerTypes = {
    Rutab: 'rutab',
    Organization: 'organization',
    Person: 'person',
};
